
export default function reducer(
  state = {
    status: "",
    error: null,

    marshals_online: 0,
    sessions: {},
  },
  action
) {
  let data
  switch (action.type) {
    case "CLEAR_STORE":
      state = defaultState()
      break;
    case "SESSION_ONLINE_COUNT":
      data = action.payload.data
      state = {
        ...state,
        error: null,
        status: "SESSION_ONLINE_COUNT",
        marshals_online: data.marshals_online,
        sessions: { ...state.sessions, ...data.sessions }
      }
      break;
    case "SESSION_STARTED":
      data = action.payload.data
      state = {
        ...state,
        error: null,
        status: "SESSION_STARTED",
        sessions: { ...state.sessions, ...data }
      }
      break;
    case "SESSION_DELETE":
      state = __session_destroyByTrackerId(state, action.payload.data)
      break;
    case "SESSION_ONLINE_FULFILLED":
      data = action.payload.data

      state = {
        ...state,
        error: null,
        status: "SESSION_ONLINE_FULFILLED",
        marshals_online: data.count
      }
      break;
    default:
      return state;
  }
  return state;
}

function defaultState() {
  return {
    status: "",
    error: null,

    marshals_online: 0,
    sessions: {},
  }
}
function __session_destroyByTrackerId(state, trackerId) {
  /*eslint no-unused-vars: ["error", { "ignoreRestSiblings": true }]*/

  const __state = { ...state }
  const { sessions, ..._state } = __state

  const key = trackerId + ''
  const { [key]: ignored, ...rest } = sessions

  const new_state = { ..._state, sessions: rest }

  return new_state
}


// WEBPACK FOOTER //
// ./src/redux/reducers/_sessions.js